// Mapea los items de pagoRequest a pagosForm para FE, pero todas las formas de pago como "efectivo"
export function mapPagosForm(pagoRequest: PayVentaRequest): (FormPago & { monedaId: string })[] {
  const pagosForm: (FormPago & { monedaId: string })[] = [];
  (pagoRequest.pago.items || [])
    .filter(it => isMontoActive(it.monto))
    .forEach(it => {
      (it.monto.items || []).forEach(mi => {
        if (isMontoActive(it.monto)) {
          pagosForm.push({
            tipoPago: "efectivo",
            monto: mi.cantidad,
            monedaId: mi.monedaId
          });
        }
      });
    });
  return pagosForm;
}

// Construye el objeto pagoFERequest
export function buildPagoFERequest({
  pagoRequest,
  dEst,
  dPunExp,
  condicionPago,
  monedaBase,
}: {
  ventaRequest: VentaRequest,
  pagoRequest: PayVentaRequest,
  dEst: string,
  dPunExp: string,
  condicionPago: any,
  monedaBase: Moneda
}) {
  return {
    pago: pagoRequest,
    dEst,
    dPunExp,
    iTipEmi: 1,
    iTipTra: 1,
    iIndPres: 1,
    iTImp: 1,
    monedaId: pagoRequest?.pago.monedaOperacionId,
    dTiCam: monedaBase.simbolo == "PYG" ? parseFloat((pagoRequest?.pago.conversionGuarani ?? 1).toFixed(2))
      : parseFloat((1 / (pagoRequest?.pago.conversionGuarani ?? 1)).toFixed(2)),
    dCondTiCam: 1,
    condicionPago
  };
}
import { VentaRequest } from "@/features/inventario/ventas/api/add-venta";
import { isMontoActive, mapMonedaValues } from "@/features/monetizacion/shared/utils";
import { Cotizacion } from "@/shared/types/cotizacion";
import { Moneda } from "@/shared/types/moneda";
import { TransferenciaMetodo } from "@/shared/types/transferencia-metodo";
import { CreateAndPayVentaConFERequest } from "../api/create-and-pay-venta-fe";
import { PayVentaRequest } from "../api/pay-venta";
import { mapCondicionPago, type FormPago } from "@/features/facturacion-electronica/utils/condicion-pago-mapper";

export interface BuildCreateAndPayFERequestParams {
  ventaRequest: VentaRequest;
  pagoRequest: PayVentaRequest;
  monedaBase: Moneda;
  cotizacion: Cotizacion;
  transferenciaMetodos: TransferenciaMetodo[];
  dEst: string;
  dPunExp: string;
}

/*function mapMetodoToTipoPago(nombre?: string): FormPago["tipoPago"] {
  const normalized = (nombre || "").toLowerCase();
  if (normalized.includes("efectivo")) return "efectivo";
  if (normalized.includes("cheque")) return "cheque";
  if (normalized.includes("debito") || normalized.includes("d\u00e9bito")) return "tarjeta_debito";
  if (normalized.includes("credito") || normalized.includes("cr\u00e9dito")) return "tarjeta_credito";
  if (normalized.includes("transf") || normalized.includes("banco")) return "transferencia";
  return "efectivo";
}*/

// Determinar la forma de pago principal (la de mayor monto en moneda base)
type PagoConMoneda = FormPago & { monedaId: string };

export function getFormaPagoPrincipal(pagos: PagoConMoneda[], cotizacion: Cotizacion, monedaBase: Moneda): PagoConMoneda | null {
  let maxMonto = 0;
  let principal: PagoConMoneda | null = null;
  pagos.forEach(pago => {
    const montoEnBase = mapMonedaValues(cotizacion, pago.monto, pago.monedaId, monedaBase.id);
    if (montoEnBase > maxMonto) {
      maxMonto = montoEnBase;
      principal = pago;
    }
  });
  return principal;
}

export function buildCreateAndPayFERequest({
  ventaRequest,
  pagoRequest,
  dEst,
  dPunExp,
  monedaBase
}: BuildCreateAndPayFERequestParams): CreateAndPayVentaConFERequest {
  const pagosForm = mapPagosForm(pagoRequest);
  const condicionPago = mapCondicionPago({
    condicionOperacion: "contado",
    pagos: pagosForm,
  });
  return {
    ventaRequest,
    pagoFERequest: buildPagoFERequest({
      ventaRequest,
      pagoRequest,
      dEst,
      dPunExp,
      condicionPago,
      monedaBase
    })
  };
}
